import { useRef } from 'react'
import {
  SActionBtn,
  SFuncModal,
  SIDRender,
  SListTabs,
  SLowcodeList,
  STableActions,
} from 'shj-components'

import {
  fetchCustomerTalkOrderPage,
  getMeetReport,
} from '@/services/productContentConfig/customer.ts'
import configMap from '@/pages/productContentConfig/customer/configuration'
import { useNavigate } from 'react-router-dom'
import { cloneDeep } from 'lodash-es'
import MeetReportEle from './editor/reportModal.tsx'

interface IProps {
  config?: Record<string, any>
  detailKey?: string
}

const CustomerTableList = (props: IProps) => {
  const navigate = useNavigate()
  // const { detailKey } = props;
  // const config = cloneDeep(props.config);
  const config = cloneDeep(configMap['negotiation'])
  const detailKey = 'negotiation'
  const listRef = useRef<any>()

  // 表格加载
  const fetchList = (values: { current: number; pageSize: number; query: any }) => {
    const { current, pageSize, query } = values
    return new Promise((resolve, reject) => {
      try {
        fetchCustomerTalkOrderPage({ params: { pageId: current, pageSize }, data: query }).then(
          data => resolve(data)
        )
      } catch (e) {
        reject({ success: false })
      }
    })
  }

  // 到店 - 按钮
  const onArrival = () => {
    localStorage.removeItem('orderId')
    window.open('/deal/home', '_blank')
  }

  const onEditMeetEditor = record => {
    if (record.caseReport) {
      navigate('/config/meetReportEditor', {
        state: {
          id: record.id,
          caseReport: record.caseReport,
          budgetInfo: record.budgetInfo,
        },
      })
    } else
      getMeetReport(record.id).then(res => {
        if (res) {
          navigate('/config/meetReportEditor', {
            state: { id: record.id, budgetInfo: record.budgetInfo },
          })
        }
      })
  }

  const onMeetEditorDetail = (record: Record<string, any>) => {
    if (record.caseReport) {
      SFuncModal({
        title: '见面报告详情',
        footer: [],
        content: <MeetReportEle {...record} />,
      })
    } else
      getMeetReport(record.id).then(res => {
        if (res) {
          SFuncModal({
            title: '见面报告详情',
            footer: [],
            content: <MeetReportEle {...record} />,
          })
        }
      })
  }

  const onDetail = record => {
    // if (detailKey === 'customized') {
    //   onMeetEditorDetail(record)
    //   return
    // }

    localStorage.setItem('orderId', record.id)
    let URL: string = ''
    switch (detailKey) {
      // case 'demand':
      //   URL += `/deal/basetd/understand/about?hasRight=true&hasEdit=false`
      //   break
      // case 'recommend':
      //   URL += `/deal/basetd/understand/about?hasLeft=true&hasEdit=false`
      //   break
      default:
        URL += `/deal/basetd/understand/about`
        break
    }
    window.open(URL, '_blank') // 触发路由导航
  }

  const extension = {
    request: { fetchList },
    events: { onArrival },
    status: {
      btnDisabled: ({ selectedRowKeys }: any) => selectedRowKeys.length <= 0,
    },
    customRender: {
      IDRender(text: any, record: { [key: string]: any }) {
        return (
          <SIDRender
            id={text}
            onClick={() => {
              onDetail(record)
            }}
          />
        )
      },
      operationCell(_: undefined, record: { [key: string]: any }) {
        return (
          <STableActions>
            <SActionBtn onClick={() => onDetail(record)}>编辑</SActionBtn>
            <SActionBtn onClick={() => onEditMeetEditor(record)}>见面报告</SActionBtn>
          </STableActions>
        )
      },
      // actionRender(_, record: Record<string, any>) {
      //   return <SActionBtn onClick={() => onDetail(record)}>详情</SActionBtn>
      // }
    },
  }

  return <SLowcodeList config={config} ref={listRef} {...extension} />
}

// const CustomerTabList = () => {
//   const itemList: any[] = []

//   for (const key in configMap) {
//     const item = {
//       key,
//       label: configMap[key].listTitle,
//       children: <CustomerTableList config={configMap[key]} detailKey={key} />,
//     }
//     itemList.push(item)
//   }

//   return <SListTabs items={itemList} destroyInactiveTabPane />
// }

export default CustomerTableList
